import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import team2 from "../assets/abt1.png";
import team3 from "../assets/ABT3.jpg";
import team1 from "../assets/HOne.jpg";

// ✅ UPDATED: Animation Variants
const containerVariants = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 60, damping: 18, duration: 0.8 },
  },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.92, x: -60 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: { type: "spring", stiffness: 70, damping: 16, duration: 1 },
  },
};

const textVariants = {
  hidden: { opacity: 0, x: 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { delay: 0.2, type: "spring", stiffness: 60, damping: 16 },
  },
};

function AboutPreview() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, threshold: 0.2 }); 

  return (
    <motion.section
      ref={ref}
      className="bg-white py-16 px-4 sm:px-8 lg:px-20" 
      variants={containerVariants} 
      initial="hidden" 
      animate={isInView ? "visible" : "hidden"} 
    >
      <div className="max-w-6xl mx-auto">
        {/* Header Text */}
        <motion.div className="text-center mb-12" variants={textVariants}>
          <p className="text-sm text-orange-600 font-semibold">About Us</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
            Engineering Excellence. Technology Driven.{" "}
            <br className="hidden sm:block" />
            Safety Focused.
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto sm:text-lg md:text-xl ">
            we ensures seamless integration of technology and engineering for
            reliable, efficient, and future-ready infrastructure.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10 items-start">
          {/* Left: Images */}
          <motion.div className="space-y-6" variants={imageVariants}>
            <div className="grid grid-cols-2 gap-4">
              <img
                src={team1}
                alt="Team 1"
                className="rounded-lg w-full object-cover h-48 sm:h-56 md:h-60"
              />
              <img
                src={team3}
                alt="Team 3"
                className="rounded-lg w-full object-cover h-48 sm:h-56 md:h-60"
              />
            </div>

            <img
              src={team2}
              alt="Team 2"
              className="rounded-lg w-full object-cover h-48 sm:h-56 md:h-60"
            />
          </motion.div>

          {/* Right: Text + Progress Bars */}
          <motion.div className="flex flex-col" variants={textVariants}>
            <p className="text-gray-700 sm:text-lg md:text-xl leading-relaxed">
              We deliver turnkey solutions across construction and civil works,
              ICT and IoT systems, electrical installations, and fire protection
              systems. Our expertise spans across technical domains that demand
              precision, innovation, and compliance. We work closely with
              clients to deliver tailor-made solutions that meet industry
              standards while embracing modern technologies.
            </p>

            {/* Progress Bars */}
            <div className="space-y-3 pt-8">
              {[
                [
                  "Construction & Civil Works",
                  "90%",
                  "bg-orange-600",
                  "w-[90%]",
                ],
                ["ICT & IoT Systems", "85%", "bg-blue-500", "w-[85%]"],
                ["Electrical Installations", "80%", "bg-yellow-500", "w-[80%]"],
                ["Fire Protection Systems", "95%", "bg-red-600", "w-[95%]"],
              ].map(([title, percent, color, width], idx) => (
                <div key={idx}>
                  <div className="flex justify-between mb-1 text-gray-800 font-medium text-sm sm:text-base">
                    <span>{title}</span>
                    <span>{percent}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className={`${color} h-2.5 rounded-full ${width}`}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/about">
              <button
                className="mt-8 w-fit px-6 py-2 bg-orange-600 text-white rounded-xl 
               hover:bg-white hover:text-orange-600 border border-transparent 
               hover:border-orange-600 transition-all duration-300 text-sm sm:text-base"
              >
                About Us →
              </button>
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}

export default AboutPreview;
